import { render, staticRenderFns } from "./ReviewAmu.vue?vue&type=template&id=c14a0b4e&"
import script from "./ReviewAmu.vue?vue&type=script&lang=js&"
export * from "./ReviewAmu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports